// Stub for @capacitor/core when Capacitor is not available
// This allows the app to build and run without Capacitor dependencies

export const Capacitor = {
  getPlatform: () => 'web',
  isNativePlatform: () => false,
  isPluginAvailable: () => false,
  convertFileSrc: (filePath) => filePath,
}

export default Capacitor

